export const PHONE_COUNTRY_SELECT_CREATED_EVENT = 'phoneCountrySelect:created';
